import { ComponentPropsWithRef, forwardRef } from 'react';
import { LuChevronDown } from 'react-icons/lu';
import { twMerge } from 'tailwind-merge';

interface Props extends ComponentPropsWithRef<'select'> {
  className?: string;
}
const BASE_CLASSES =
  'carina-select inline-block rounded-sm bg-white font-light [&_option]:text-left [&_option]:flex [&_option]:flex-col [&_option]:justify-center [&_option]:items-center text-center active:outline-primary hover:outline-primary active:rounded-b-none py-2 px-4 w-full border-transparent outline outline-primary outline-1 border-r-8 placeholder-gray-200 cursor-pointer';

const Select = forwardRef<HTMLSelectElement, Props>(
  ({ className, children, ...otherProps }: Props, ref) => {
    return (
      <span className="relative">
        <select className={twMerge(BASE_CLASSES, className)} {...otherProps} ref={ref}>
          {children}
        </select>
        <LuChevronDown className="text-primary absolute pointer-events-none right-2 top-1/2 h-6 w-6 -translate-y-1/2" />
      </span>
    );
  }
);

Select.displayName = 'Select';

export default Select;
